'use client';
import { ReactNode, createContext } from 'react';
import { PageTitle } from '@/schema/getStaticPageUrl';
import { FirebaseTopics } from '@/shared/lib/firebase-topic';
import { LocalizedString, LocalizedValue } from '@/shared/model/Language';
import { VenueRouterMode } from '../venue-router';

type SocialLinks = {
    facebook?: LocalizedString;
    instagram?: LocalizedString;
    youtube?: LocalizedString;
};

type AppLinks = {
    googlePlay?: string;
    appStore?: string;
};

type MobileApp = {
    /** Android applicationId of the whitelabel app; doubles as its URL scheme. */
    androidPackage?: string;
    /** iOS bundle id of the whitelabel app; doubles as its URL scheme. */
    iosBundleId?: string;
};

export type VenueRouterAppConfig = {
    showRouter: boolean;
    mode: VenueRouterMode | `${VenueRouterMode}`;
    /** Localized path of pages["venue-router"] (e.g. /rozcestnik). */
    path: string;
};

type ContextValue = {
    routes: Partial<Record<PageTitle, string>>;
    allRoutes?: Record<PageTitle, LocalizedValue<string>>;
    logo: { src: string | null; alt?: string | null };
    footerLogo: { src: string | null; alt?: string | null };
    apiPartnerCode: 'ESHOP' | 'APPLICATION';
    apiPartnerSettingsId: string;
    socialLinks?: SocialLinks;
    appLinks?: AppLinks;
    mobileApp?: MobileApp;
    /** Notification topic per language the whitelabel app subscribes its device to. */
    firebaseTopics?: FirebaseTopics;
    venueLogoUrl?: string | null;
    verifyTelephoneEnabled: boolean;
    // TODO: Remove — dočasná sleva na první objednávku.
    firstOrderDiscountEnabled: boolean;
    termsAndConditions: string;
    privacyPolicy: string;
    venueRouter?: VenueRouterAppConfig | null;
};

export const AppConfigContext = createContext<ContextValue>({
    routes: {},
    logo: { src: '#' },
    footerLogo: { src: '#' },
    apiPartnerCode: 'ESHOP',
    apiPartnerSettingsId: '',
    venueLogoUrl: null,
    verifyTelephoneEnabled: true,
    // TODO: Remove — dočasná sleva na první objednávku.
    firstOrderDiscountEnabled: false,
    termsAndConditions: '',
    privacyPolicy: '',
    venueRouter: null,
});

type Props = ContextValue & {
    children?: ReactNode;
};

export const AppConfigProvider = ({ children, ...value }: Props) => {
    return <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>;
};
